'use strict';
const angular = require('angular');

export class SubmissionSectionConfirmationComponent {
  constructor($state, $scope, $rootScope, fetch, lookup) {
    'ngInject';

    this.$scope = $scope;
    this.fetch = fetch;
    this.lookup = lookup;

    //  DENSITY FUNCTIONS 
  
    /**
     * Submit density - Submits commercial or residential zoning data as well as residential verification form data for review
     * saving       : set saving messages and icons
     * upsertData   : variable for holding all density submission types for update
     * submitted    : flag for setting various messages and icons
     */
    // $scope.submitDensity = function(){
    //   if(!$scope.currentSelectedStationId){
    //     /**
    //      * todo: Show error message if no station is selected
    //      */
    //   } else {
    //     $scope.saving = true;
    //     var upsertData = [];
    //     fetch.getAllItems(`api/data/submissionsbytype/${$scope.currentJurisdiction}/Density`)
    //     .then(response => {
          
    //       var stationData = _.filter(response.data,{sta_recid: $scope.currentSelectedStationId});
    //       stationData.forEach(element => {
    //         if($scope.densityType === 'Residential'){
    //           if(element.submission_policy_name === 'Minimum Density Residential'){
    //             if($scope.currentStation.weighted_average_toc_min_dua >= 0){
    //               element.min_dua = $scope.currentStation.weighted_average_toc_min_dua;
    //               element.submitted = true;
    //               upsertData.push({
    //                 submission_id: element.submission_id,
    //                 min_dua: element.min_dua,
    //                 submitted: true
    //               });
    //             }
    //           } else if(element.submission_policy_name === 'Maximum Density Residential'){
    //             if($scope.currentStation.weighted_average_toc_max_dua >= 0){
    //               element.max_dua = $scope.currentStation.weighted_average_toc_max_dua;
    //               element.submitted = true;
    //               upsertData.push({
    //                 submission_id: element.submission_id,
    //                 max_dua: element.max_dua,
    //                 submitted: true
    //               });
    //             }
    //           }
    //         }
           
    //         if($scope.densityType === 'Commercial'){
    //           if (element.submission_policy_name === 'Minimum FAR Office') {
    //             if ($scope.currentStation.weighted_average_toc_min_far >= 0) {
    //               element.min_far = $scope.currentStation.weighted_average_toc_min_far;
    //               element.submitted = true;
    //               upsertData.push(element);
    //             }
    //           } else if (element.submission_policy_name === 'Maximum FAR Office') {
    //             if ($scope.currentStation.weighted_average_toc_max_far >= 0) {
    //               element.max_far = $scope.currentStation.weighted_average_toc_max_far;
    //               element.submitted = true;
    //               upsertData.push(element);
    //             }
    //           }
    //         }
    //       });
    //       fetch.updateItem(`api/data/submissions/update`, upsertData)
    //       .then(response => {
            
    //         $scope.submitted = true;
    //         $scope.saving = false;
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       })
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if(err.status === 403){
    //         $state.go('login');
    //       }
    //     })
    //   }
     
    // }

    $scope.submitDensity = function () {
      if (!$scope.currentSelectedStationId && !$scope.submitDensityForReview) {
        // TODO: Show error message if no station is selected
        return;
      }

      $scope.saving = true;
      var upsertData = [];

      $scope.updateCurrentDensityPolicy()
    
      fetch.getAllItems(`api/data/submissionsbytype/${$scope.currentJurisdiction}/Density`)
        .then(response => {
          var stationData = _.filter(response.data, { sta_recid: $scope.currentSelectedStationId });
    
          // console.log("submissing", $scope.density.residentialUsesCheck, $scope.residentialUses.length)
          stationData.forEach(element => {
            // --- Residential Submission ---
            if ($scope.densityType === 'Residential') {
              if (element.submission_policy_name === 'Residential Uses Data Verification') {
                console.log('Found Residential Uses policy record:', element);
                console.log('Current $scope.submissions:', $scope.submissions);
                console.log('Is "Residential Uses Data Verification" in submissions?', $scope.submissions ? $scope.submissions.includes('Residential Uses Data Verification') : 'submissions undefined');
                console.log('Is element already submitted?', element.submitted);

                if ($scope.submissions && $scope.submissions.includes('Residential Uses Data Verification') && !element.submitted) {
                  upsertData.push({
                        submission_id: element.submission_id,
                        density_residential_uses: true,
                        submitted: true,
                      });
                    }
            }
    
              else if (element.submission_policy_name === 'Minimum Density Residential') {
                if ($scope.currentStation.weighted_average_toc_min_dua >= 0) {
                  element.min_dua = $scope.currentStation.weighted_average_toc_min_dua;
                  element.submitted = true;
                  upsertData.push({
                    submission_id: element.submission_id,
                    min_dua: element.min_dua,
                    submitted: true
                  });
                }
              } else if (element.submission_policy_name === 'Maximum Density Residential') {
                if ($scope.currentStation.weighted_average_toc_max_dua >= 0) {
                  element.max_dua = $scope.currentStation.weighted_average_toc_max_dua;
                  element.submitted = true;
                  upsertData.push({
                    submission_id: element.submission_id,
                    max_dua: element.max_dua,
                    submitted: true
                  });
                }
              }
            }
    
            // --- Commercial Submission ---
            if ($scope.densityType === 'Commercial') {
              if (element.submission_policy_name === 'Commercial Office Uses Data Verification') {
                console.log('Found Commercial Office Uses policy record:', element);
                console.log('Current $scope.submissions:', $scope.submissions);
                console.log('Is "Commercial Office Uses Data Verification" in submissions?', $scope.submissions ? $scope.submissions.includes('Commercial Office Uses Data Verification') : 'submissions undefined');
                console.log('Is element already submitted?', element.submitted);
                if ($scope.submissions && $scope.submissions.includes('Commercial Office Uses Data Verification') && !element.submitted) {
                  upsertData.push({
                        submission_id: element.submission_id,
                        density_commercial_uses: true,
                        submitted: true,
                      });
                    }
              };
    
              if (element.submission_policy_name === 'Minimum FAR Office') {
                if ($scope.currentStation.weighted_average_toc_min_far >= 0) {
                  element.min_far = $scope.currentStation.weighted_average_toc_min_far;
                  element.submitted = true;
                  upsertData.push({
                    submission_id: element.submission_id,
                    min_far: element.min_far,
                    submitted: true
                  });
                }
              } else if (element.submission_policy_name === 'Maximum FAR Office') {
                if ($scope.currentStation.weighted_average_toc_max_far >= 0) {
                  element.max_far = $scope.currentStation.weighted_average_toc_max_far;
                  element.submitted = true;
                  upsertData.push({
                    submission_id: element.submission_id,
                    max_far: element.max_far,
                    submitted: true
                  });
                }
              }
            }
          }
        );
    
    
          // Save the data
          fetch.updateItem('api/data/submissions/update', upsertData)
            .then(response => {

              console.log('Submitted Policies:', response.data);
              
              $scope.saving = false;
              $scope.submitted = true;
              $scope.saved = true;
              $scope.pendingChanges = false;
              setTimeout(() => {
                $scope.submitmode = null;
                $scope.saved = false;
                $scope.$apply();
              }, 2000);
            })
            .catch(err => {
              console.log(err);
              if (err.status === 403) {
                $state.go('login');
              }
            });
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    };
    /**
    * Function to update residential or commerical zoning code tables
    * Variable definitions
    * saving (true/false)           : Flag to show saving messages and icons e.g., fa-cog spin
    * pendingChangesCount           : Show number of parcels that will be affected by pending zoning code update 
    * saved (true/false)            : Flag showing saved messages and icons
    * showPendingCount (true/false) : Flag showing pendingChangesCount and associated text
    * saveType                      : Text showing on save button
    * currentStation                : Currently selected station area
    * Fn getStationbyId             : Function retrieving weighted averages for density
    * setTimeout                    : Function for how long saved messages show. Set to 3 seconds
    */
  $scope.saveZoningCodes = function () {
  $scope.saving = true;
  fetch.updateItem(`api/data/density/zoning/update`, $scope.updateData)
    .then(response => {
      $scope.pendingChangesCount = {};
      $scope.updateData = [];
      $scope.pendingChanges = false;
      $scope.saved = true;
      $scope.saving = false;
      $scope.success = true;
      $scope.showPendingCount = false;
      $scope.saveType = null;
     
      // Refresh weighted averages immediately
      $scope.getStationbyID();
      
      // Force digest cycle to update bindings
      setTimeout(() => {
        $scope.$apply();
      }, 100); // Small delay to ensure API call completes

      setTimeout(() => {
        $scope.success = false;
        $scope.savemode = null;
        $scope.saved = false;
        $scope.successMessage = null;
        $scope.$apply();
      }, 10000);
    })
    .catch(err => {
      console.log(err);
    })
}
    /**
     * Cancel Updates
     * Cancels any pending zoning code updates and resets handsontable to previous unchanged state
     * Resets pendingChanges flag and pendingChangesCount
     */
    $scope.cancelUpdates = function () {
      $scope.pendingChanges = false;
      $scope.pendingChangesCount = [];
      $scope.savemode = null;
      for (let index = 0; index < $scope.updateData.length; index++) {
        $scope.hot.undo();
      }
    }

    /**
     * Before Save Event
     * Retrieves pendingChangesCount, i.e., total count of parcels that will be affected by zoning code save
     * @param {*} zn_updates 
     */
    $scope.beforeSave = function () {
      $scope.savemode = 'density';
      $scope.saveType = 'Save Zoning Changes';
      $scope.showPendingCount = true;
      fetch.updateItem(`api/data/parcels/zoning/counts/${$scope.currentJurisdiction}`, $scope.updateData)
        .then(response => {
          
          $scope.pendingChangesCount = response.data;
          $scope.pendingChanges = true;
          // $scope.$apply();
        })
        .catch(err => {
          console.log(err);
        })

    }


  }

  /**
   * Set variable for page title, navigate to page url
   * @param {*} page 
   */
  gotoPage(page, subPage) {
    if (subPage) {
      this.$location.url(subPage.url);
      this.$rootScope.subItem = subPage;
      this.subNavActive(subPage);
      this.navService.setBreadCrumb(page, subPage);
    } else {
      this.$rootScope.page = page;
      this.$rootScope.subItem = null;
      this.$location.url(page.url);
      this.navService.setBreadCrumb(page);
    }
  }

  /**
   * Set page name and sub menu details
   * @param {*} subItem 
   * @param {*} item 
   */
  updateBreadcrumb(subItem, item) {
    this.$rootScope.page = item;
    this.$rootScope.subItem = subItem;
    this.$location.url(subItem.url);
    this.showSubNav(item);
    this.subNavActive(item, subItem);
  }

  /**
   * Expand dropdown menu on page load if there are submenu items
   * @param {*} page 
   */
  // showSubNav(page){
  //   this.$scope.menu.forEach(item => {
  //     if(item.title === page.title){
  //       item.expanded = true;
  //       console.log('set item to true');
  //       console.log(item);
  //     } else {
  //       item.expanded = false;
  //     }
  //   });
  // }

  /**
   * Set current sub menu link to active
   * @param {*} page 
   * @param {*} subItem 
   */
  subNavActive(subPage) {
    this.$scope.menu.forEach(element => {
      if (element.subItem1) {
        for (let index = 0; index < element.subItem1.length; index++) {
          const checkUrl = element.subItem1[index].url;
          if (checkUrl.url !== subPage.url) {
            element.subItem1[index].active = false;
          }

        }
      }
    });
    subPage.active = true;
  }
}

export default angular.module('appApp.submissionsectionsubmit', [])
  .directive('submissionsectionsubmit', function () {
    return {
      template: require('./submissionsectionsubmit.html'),
      restrict: 'EA',
      controller: SubmissionSectionConfirmationComponent,
      controllerAs: 'submissionSectionCtrl',
      link: function (scope, element, attrs) { }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/submissionsectionsubmit/submissionsectionsubmit.directive.js